import { OrderItem } from './../../class/OrderItem';
import { OrderItemApproval } from '../../class/OrderItemApproval';
import { OrderSub } from '../../class/OrderSub';
import { OrderInfo } from '../../class/OrderInfo';
import { Router } from '@angular/router';
import { SubService } from '../../service/sub.service';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { forkJoin } from 'rxjs';
import * as _ from 'lodash/core';
import { RetailStoreData } from 'src/app/class/RetailStoreData';

@Component({
  selector: 'app-item-approval',
  templateUrl: './item-approval.component.html',
  styleUrls: ['./item-approval.component.scss']
})
export class ItemApprovalComponent implements OnInit {
  orderInfo: OrderInfo;
  orderSubs: Array<OrderSub>;
  custSubs: Array<OrderSub>;
  backupSubs: Array<OrderSub>;
  orderOutOfStocks: Array<OrderItem>;
  orderAddonItems: Array<OrderItem>;
  completedSubs: Array<OrderSub>;
  completedBkpSubs: Array<OrderSub>;
  completedAllSubs: Array<OrderSub>;
  approvedSubs: Array<OrderSub>;
  approvedBkpSubs: Array<OrderSub>;
  approvedAllSubs: Array<OrderSub>;
  retailStore: RetailStoreData;
  isActive = false;
  pageReady = false;
  isLoading = false;

  constructor(
    private subService: SubService,
    private router: Router,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    const observable = [
      this.subService.getOrder(),
      this.subService.getSubsRemaining(),
      this.subService.getCustSubsRemaining(),
      this.subService.getBackupSubsRemaining(),
      this.subService.getOutOfStockItems(),
      this.subService.getAddonItems(),
      this.subService.getRetailStore()
    ];

    forkJoin(observable).subscribe((results: any) => {
      this.orderInfo = results[0];
      this.orderSubs = results[1];
      this.custSubs = results[2];
      this.backupSubs = results[3];
      this.orderOutOfStocks = results[4];
      this.orderAddonItems = results[5];
      this.retailStore = results[6];
      this.pageReady = true;
    });
  }

  approve(item) {
    item.isSubApproved = 'Y';
  }

  reject(item) {
    item.isSubApproved = 'N';
  }

  receiveAcceptData(item) {
    this.approve(item);
  }

  receiveRejectData(item) {
    this.reject(item);
  }

  submit() {
    this.completedSubs = this.orderSubs.reduce((acc, x) => {
      if (x.isSubApproved === 'Y' || x.isSubApproved === 'N') {
        acc.push(x);
      }
      return acc;
    }, []);

    if (this.retailStore.isCustomerChoiceEnabled) {
      this.completedBkpSubs = this.backupSubs.reduce((acc, x) => {
        if (x.isSubApproved === 'Y' || x.isSubApproved === 'N') {
          acc.push(x);
        }
        return acc;
      }, []);
    }

    if (this.completedSubs.length !== this.orderSubs.length || 
      (this.retailStore.isCustomerChoiceEnabled && this.completedBkpSubs.length !== this.backupSubs.length)) {
      alert('Please complete all Items');
      return;
    }

    this.approvedSubs = this.completedSubs.filter((x) => x.isSubApproved === 'Y');

    this.approvedAllSubs = this.approvedSubs;
    this.completedAllSubs = this.completedSubs;

    if (this.retailStore.isCustomerChoiceEnabled) {
    
      this.approvedBkpSubs = this.completedBkpSubs.filter((x) => x.isSubApproved === 'Y');
      this.approvedAllSubs = this.approvedSubs.concat(this.approvedBkpSubs);
      
      this.completedAllSubs = this.completedSubs.concat(this.completedBkpSubs);

      // customer choice subs need no approval
      _.forEach(this.custSubs, (custSub) => {
        custSub.isSubApproved = 'Y';
      })

      // indicates there was nothing to approve.. only needed to display new message, and move to finish
      if (this.custSubs.length >= 1 && this.approvedAllSubs.length < 1 && this.completedAllSubs.length < 1) {
        this.finish();
      } else {
        this.showModal();
      }
      this.completedAllSubs = this.completedAllSubs.concat(this.custSubs);
    } else {
      this.showModal();
    }
  }

  finish() {
    // show spinner or overlay
    this.isLoading = true;

    const changes = _.reduce(
      this.completedAllSubs,
      (result, orderSub: OrderSub) => {
        const orderItemApproval: OrderItemApproval = new OrderItemApproval();
        orderItemApproval.isSubApproved = orderSub.isSubApproved;
        orderItemApproval.LNITEM_SEQ_NUM = orderSub.newItem.LNITEM_SEQ_NUM;
        result.push(orderItemApproval);
        return result;
      },
      new Array<OrderItemApproval>()
    );

    this.subService.postSubApprovals(changes).subscribe(
      () => {
        this.hideModal();
        this.router.navigate(['welcome/final'], {
          skipLocationChange: true,
          queryParamsHandling: 'preserve'
        });
      },
      (error) => {
        alert('Sorry something has gone wrong');
        this.isLoading = false;
      }
    );
  }

  showModal() {
    this.isActive = true;
    this.renderer.addClass(document.documentElement, 'is-clipped');
  }

  hideModal() {
    this.isActive = false;
    this.renderer.removeClass(document.documentElement, 'is-clipped');
  }
}
